// Blog UI chrome (listing + post pages). The post content itself (titles,
// excerpts, bodies, footnotes) is translated via `_sk` fields on the data in
// src/data/blog.ts, not here.
const blog = {
  // Listing page
  backHome: 'Back home',
  eyebrow: 'Writing',
  title: 'Blog',
  subtitle: 'Thoughts, experiences, and reflections.',
  pinned: 'Pinned',
  readArticle: 'Read article',
  minRead: 'min read',
  techChip: 'Tech',
  chaptersOngoing: 'chapters · ongoing',
  techTitle: 'Tech I love',
  techExcerpt:
    'The gear I actually use every day, with my own notes, photos and clips on what I like, what I do not, and why it matters to me.',
  seoTitle: 'Blog',
  seoDescription:
    'Writing by Eduard Hvizdak: thoughts on AI engineering, building SaaS, hackathons, and life.',

  // Post page
  allPosts: 'All posts',
  readingFontAria: 'Reading font',
  fontSerif: 'Serif',
  fontSans: 'Sans',
  writtenBy: 'Written by',
  authorBio:
    'AI engineer and founder. I build SaaS and AI products, compete at hackathons, and write about what I learn along the way.',
  moreFromBlog: 'More from the blog',
  imagePreview: 'Image preview',
};

export default blog;
